// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"style_breadcrumb__2mi3b","breadcrumbLink":"style_breadcrumbLink__drS4e"};